'use client';

import { cloneElement, ReactElement } from 'react';
import { ButtonComponentProps } from '../../types';
import { useModalDrawerContext } from '../ModalDrawerContext/ModalDrawerContext';

/**
 * Button that triggers opening a drawer when clicked
 */
export const DrawerTriggerButton = <
  TProps extends object = Record<string, unknown>,
>({
  DrawerComponent,
  drawerProps,
  isDrawerOpeningNotAllowed,
  onClick,
  children,
}: {
  DrawerComponent: (props: TProps) => ReactElement;
  drawerProps?: TProps;
  isDrawerOpeningNotAllowed?: boolean;
  onClick?: () => void;
  children: ReactElement<ButtonComponentProps>;
}) => {
  const { openDrawer } = useModalDrawerContext();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    if (isDrawerOpeningNotAllowed) return;

    openDrawer(DrawerComponent, drawerProps);
  };

  return cloneElement(children, {
    onClick: handleClick,
    'data-drawer-trigger': 'true',
  });
};
